import React, { forwardRef } from 'react';
import { MenuItem, MenuItemProps, styled, TextFieldProps } from '@mui/material';

export const CustomSidebarMenuItem = styled(
    ({ ...props }: MenuItemProps) => (
        <MenuItem {...props} />
    )
    )(({ theme }) => ({
    "&.Mui-selected": {
        color: `${theme.palette.primary[400]}`,
        backgroundColor: 'white'
    },
    "&.Mui-selected:hover": {
        color: `${theme.palette.primary[400]}`,
        backgroundColor: 'white'
    },
    "&:hover": {
        color: `${theme.palette.primary[400]}`,
        backgroundColor: 'white'
    }
}));

// eslint-disable-next-line react/display-name
const StyledSidebarMenuItem = forwardRef((props: MenuItemProps, ref) => {
    return (
        <CustomSidebarMenuItem
            {...props}

        />
    );
});

export default StyledSidebarMenuItem;
